import { Directive } from '@angular/core';

import { PriceOddsValueDirective } from '../priceOddsButton/price-odds-value.directive';

@Directive({
    // eslint-disable-next-line
    selector: '[priceOddsValue]',
    standalone: true,
})
export class PriceOddsSAValueDirective extends PriceOddsValueDirective {}
